import { BASE_URL } from "../utils/index";
import { postJson } from "../utils/postJson";

async function requestViajes(
  endpoint,
  payload,
  requestError,
  notFoundError,
  connectionError = requestError
) {
  try {
    return await postJson(`${BASE_URL}/${endpoint}`, payload);
  } catch (error) {
    if (error.status === 401) {
      throw new Error("La sesión no es válida. Inicia sesión de nuevo.");
    }
    if (error.status === 404 && notFoundError) {
      throw new Error(notFoundError);
    }
    if (error.status) {
      throw new Error(`${requestError} (HTTP ${error.status}). Puedes reintentar.`);
    }
    throw new Error(connectionError);
  }
}

export async function fetchViajesProgramados({
  page = 1,
  perPage = 25,
  search = "",
  filters = {},
  sortBy = "idVP",
  sortDirection = "desc",
} = {}) {
  const data = await requestViajes(
    "viajesProgramados",
    {
      idCliente: localStorage.getItem("idCliente"),
      page,
      perPage,
      search,
      filters,
      sortBy,
      sortDirection,
    },
    "No se pudieron cargar los viajes",
    null,
    "No se pudo conectar con el servidor para cargar los viajes."
  );

  if (
    !Array.isArray(data.viajes) ||
    !data.pagination ||
    !Number.isInteger(data.pagination.total) ||
    data.pagination.total < 0
  ) {
    throw new Error("El servidor devolvió una respuesta de viajes inválida.");
  }

  return data;
}

export async function fetchViajeProgramadoDetalle(idVP, origenServicio = "SERVICIO") {
  const data = await requestViajes(
    "viajeProgramadoDetalle",
    {
      idCliente: localStorage.getItem("idCliente"),
      idVP,
      origenServicio,
    },
    "No se pudo cargar el detalle del viaje",
    "No se encontró ese viaje o ya no está disponible.",
    "No se pudo conectar con el servidor para cargar el detalle del viaje."
  );

  if (!data.viaje || String(data.viaje.idVP) !== String(idVP)) {
    throw new Error("El servidor devolvió un detalle de viaje inválido.");
  }

  return data.viaje;
}
